import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import cx from 'classnames';
import SubmitStore from './submit-button-store';

export default class SubmitButton extends Reflux.Component {
  constructor(props) {
    super(props);
    this.state = {}
    this.store = SubmitStore.get(props.questionnaire);
  }
  componentWillUnmount() {
    this.store.stopListeningToAll();
  }
  render() {
    let buttonClass = cx({
      "submit-button": true,
      "button": true,
      "disabled": this.state.isDisabled
    });
    let buttonProps = {
      className: buttonClass,
      onClick: (e) =>{
        if(this.state.isDisabled) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      }
    }
    return(
      <button {...buttonProps}>
        <span className="title">Submit</span>
      </button>
    )
  }
}

SubmitButton.propTypes={
  questionnaire: React.PropTypes.object.isRequired
}
SubmitButton.defaultProps={}



// WEBPACK FOOTER //
// ./medscape_modules/qna/form-components/submit-button.jsx